import { Link } from 'react-router-dom';
import { ArrowLeft, Bot, Sparkles } from 'lucide-react';
import ChatPanel from '@/components/ChatPanel';

/**
 * Full-page /assistant route — same ChatPanel but larger and with a marketing
 * header that explains what the assistant can do.
 */
export default function AssistantPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-emerald-950/40">
      {/* Header */}
      <div className="border-b border-slate-800 bg-slate-950/80 backdrop-blur">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/" className="text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-slate-800" data-testid="assistant-back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 grid place-items-center shadow-lg">
            <Bot className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="text-white font-black text-lg">Landi · Your HLN2026 AI Guide</div>
            <div className="text-emerald-400 text-[10px] uppercase font-black tracking-widest flex items-center gap-1.5">
              <Sparkles className="w-3 h-3" /> Powered by GPT-5.2 · Grounded on live exhibition data
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-6 grid md:grid-cols-3 gap-4">
        {/* Left column: capabilities */}
        <div className="hidden md:block space-y-3">
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-4">
            <div className="text-white font-bold text-sm mb-2">🗺️ Navigate</div>
            <div className="text-slate-400 text-xs">"Where is booth MBMB?" · "Nearest toilet from Hall B?"</div>
          </div>
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-4">
            <div className="text-white font-bold text-sm mb-2">🎉 Discover</div>
            <div className="text-slate-400 text-xs">"Any flash deals right now?" · "What's the opening ceremony time?"</div>
          </div>
          <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-4">
            <div className="text-white font-bold text-sm mb-2">📣 Exhibitor mode</div>
            <div className="text-slate-400 text-xs">"Draft a 30% off durian flash sale" · "How many people redeemed my coupon?"</div>
          </div>
        </div>

        {/* Chat */}
        <div className="md:col-span-2">
          <ChatPanel />
        </div>
      </div>
    </div>
  );
}
